"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var formik_1 = require("formik");
var react_1 = __importStar(require("react"));
require("./TextArea.scss");
var TextArea = function (props) {
    var className = props.className, _a = props.allowSubmittingDisabledState, allowSubmittingDisabledState = _a === void 0 ? true : _a, fast = props.fast, rest = __rest(props, ["className", "allowSubmittingDisabledState", "fast"]);
    var Component = react_1.useMemo(function () { return (fast ? formik_1.FastField : formik_1.Field); }, [fast]);
    return (react_1.default.createElement(Component, { name: props.name, placeholder: props.placeholder }, function (_a) {
        var field = _a.field, form = _a.form, meta = _a.meta;
        return (react_1.default.createElement("textarea", __assign({}, field, { disabled: form.isSubmitting && allowSubmittingDisabledState }, rest, { value: field.value || '', className: classnames_1.default('form-textarea', className, {
                'form-textarea--error': !!meta.error,
            }) })));
    }));
};
exports.default = TextArea;
//# sourceMappingURL=index.js.map